module.exports = __webpack_public_path__ + "static/img/passed.a137f000.png";